import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "./components/Layout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import BookingSuccessPage from "./pages/BookingSuccessPage";
import GalleryPage from "./pages/GalleryPage";
import AdminPage from "./pages/AdminPage";
import ManageBookingPage from "./pages/ManageBookingPage";
import BalanceSuccessPage from "./pages/BalanceSuccessPage";
import TipSuccessPage from "./pages/TipSuccessPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import { JOBBER_BOOKING_URL } from "./lib/brand";

// Old /book URL bookmarks — redirect to the Jobber hosted form in the same tab
const BookRedirect = () => {
  React.useEffect(() => {
    window.location.replace(JOBBER_BOOKING_URL);
  }, []);
  return (
    <div className="min-h-[60vh] flex items-center justify-center text-white">
      <div className="text-center">
        <div className="font-display uppercase tracking-widest text-[#D90429] text-sm">Redirecting…</div>
        <p className="mt-2 text-[#A3A3A3]">Taking you to our secure Jobber booking form.</p>
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/book" element={<BookRedirect />} />
            <Route path="/booking/success" element={<BookingSuccessPage />} />
            <Route path="/booking/manage/:id" element={<ManageBookingPage />} />
            <Route path="/booking/balance/success" element={<BalanceSuccessPage />} />
            <Route path="/tip/success" element={<TipSuccessPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </Layout>
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
